/**
 * TriggerAction 工具函数
 */
import { createMergeToDefaultData } from './mergeToDefaultData'
import type { ITriggerAction } from '../entities/ITriggerAction'

export interface ITriggerActionUtils {
  type: string
  createDefaultData: () => ITriggerAction
  mergeDataToDefaultData: (data: Partial<ITriggerAction>) => ITriggerAction
}

export function createTriggerActionUtils(
  type: string,
  createDefaultData: () => ITriggerAction
): ITriggerActionUtils {
  return {
    type,
    createDefaultData,
    mergeDataToDefaultData: createMergeToDefaultData(createDefaultData)
  }
}
